import { PropsWithChildren } from "react";

import Sidebar from "@components/sidebar/sidebar";

const ViewOptionsSidebar = ({
  onClose,
  additionalActions,
  children,
}: PropsWithChildren<{
  onClose: () => void;
  additionalActions?: JSX.Element;
}>) => {
  return (
    <Sidebar
      title="View Options"
      onClose={onClose}
      additionalActions={additionalActions}
    >
      {children}
    </Sidebar>
  );
};

export default ViewOptionsSidebar;
